import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface DeleteUserDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  userName: string
  userRole: string
}

export function DeleteUserDialog({
  isOpen,
  onClose,
  onConfirm,
  userName,
  userRole,
}: DeleteUserDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Kullanıcı Silme İşlemi</DialogTitle>
          <DialogDescription>
            <p><strong>{userName}</strong> ({userRole}) kullanıcısını silmek üzeresiniz.</p>
            <p className="mt-2">Bu işlem:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Kullanıcının hesabını kalıcı olarak devre dışı bırakır</li>
              <li>Kullanıcının tüm yetkilerini kaldırır</li>
              <li>Kullanıcının sistemdeki geçmiş işlemlerini arşivler</li>
              {userRole === "manager" && (
                <>
                  <li className="text-destructive">Yöneticinin firma paneline erişimini engeller</li>
                  <li className="text-destructive">Firma yönetim yetkilerini kaldırır</li>
                </>
              )}
            </ul>
            <p className="mt-4 text-destructive font-semibold">
              Bu işlem geri alınamaz! Devam etmek istediğinizden emin misiniz?
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            İptal
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            Kullanıcıyı Sil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
